import {registerExpressPaymentMethod} from '@woocommerce/blocks-registry';
import {getSettings, initStripe as loadStripe, isCartPage, isCheckoutPage} from "../util";
import {Elements} from "@stripe/react-stripe-js";
import ErrorBoundary from "../error-boundary";
import {ApplePayPreview} from "./preview";
import ApplePayExpressCheckout from "./applepay-express-checkout";

const getData = getSettings('stripe_applepay_data');

const ApplePayContent = (props) => {
    const {
        getData,
        billing
    } = props;
    const {
        cartTotal,
        currency
    } = billing;
    let options = {
        mode: 'payment',
        paymentMethodCreation: 'manual',
        currency: currency?.code?.toLowerCase(),
        appearance: {
            variables: {
                borderRadius: getData('buttonRadius')
            }
        },
        ...getData('elementOptions')
    }
    if (0 >= cartTotal.value) {
        options = {...options, mode: 'setup'}
    }
    if (['payment', 'subscription'].includes(options.mode)) {
        options.amount = cartTotal.value;
    }
    return (
        <ErrorBoundary>
            <div className='wc-stripe-apple-pay-container'>
                <Elements stripe={loadStripe} options={options}>
                    <ApplePayExpressCheckout {...props}/>
                </Elements>
            </div>
        </ErrorBoundary>
    );
}

registerExpressPaymentMethod({
    name: getData('name'),
    canMakePayment: (props) => {
        const {
            cart
        } = props;
        if (isCartPage() && !getData('cartCheckoutEnabled')) {
            return false;
        }
        if (isCheckoutPage() && !getData('expressCheckoutEnabled')) {
            return false;
        }
        const currency = cart.cartTotals.currency_code?.toLowerCase();
        const total = parseInt(cart.cartTotals.total_price);
        return new Promise(resolve => {
            return loadStripe.then(stripe => {
                let options = {
                    mode: 'payment',
                    currency,
                }
                if (0 >= total) {
                    options = {...options, mode: 'setup'}
                }
                if (['payment', 'subscription'].includes(options.mode)) {
                    options.amount = total;
                }

                const element = stripe.elements(options);

                const expressCheckoutElement = element.create('expressCheckout', {
                    paymentMethods: {
                        applePay: getData('displayRule')
                    }
                });
                expressCheckoutElement.on('ready', ({availablePaymentMethods}) => {
                    const {applePay = false} = availablePaymentMethods || {};
                    expressCheckoutElement.unmount();
                    div.remove();
                    resolve(applePay);
                });
                expressCheckoutElement.on('loaderror', () => {
                    div.remove();
                    resolve(false);
                });

                const div = document.createElement('div');
                div.style.display = 'none';
                document.querySelector('body').appendChild(div);

                expressCheckoutElement.mount(div);
            })
        })
    },
    content: <ApplePayContent getData={getData}/>,
    edit: <ApplePayPreview getData={getData}/>,
    supports: {
        showSavedCards: getData('showSavedCards'),
        showSaveOption: getData('showSaveOption'),
        features: getData('features')
    }
});
